<div class="row">
    <div class="col-md-12">
        <div class="title_div1 mt-2 row">
            <div class="col-auto">
                <h6>Sales</h6>
            </div>
            <div class="col-md-2 position-relative h-30 mb-1">
                <select name="showPolicy" id="showPolicy" class="form-select form-select-custom input_"
                    [(ngModel)]="policyType" (change)="onPolicyTypeCheck();">
                    <option *ngFor="let show of policyTypeList" [value]="show.value">
                        {{show.text}}
                    </option>
                </select>
                <label class="float-start label_ms fs-14-br-12">Policy Type</label>
            </div>
            <div class="col-md-3 position-relative h-30 mb-1" *ngIf="userType == 2">
                <app-multi-dropdown class="w-100 multiselect_custom input_ d-block" [items]="distributorList"
                    [className]="'bg-white'" [showSearch]="true" [showAll]="true" [showStatus]="false"
                    (itemChange)="onDistributorMultiSelectChange($event)" placeholder=" " id="distributorlist">
                </app-multi-dropdown>
                <label class="float-start label_ms fs-14-br-12">Distributor</label>
            </div>
            <div class="col-md-3 position-relative h-30 mb-1" *ngIf="userType == 2 || userType == 3">
                <app-multi-dropdown class="w-100 multiselect_custom input_ d-block" [items]="resellerList"
                    [className]="'bg-white'" [showSearch]="true" [showAll]="true" [showStatus]="false"
                    (itemChange)="onResellerMultiSelectChange($event)" placeholder=" " id="resellerlist">
                </app-multi-dropdown>
                <label class="float-start label_ms fs-14-br-12">Reseller</label>
            </div>
            <div class="col-md-3 position-relative h-30 mb-1" *ngIf="userType == 2 || userType == 3 || userType == 4">
                <app-multi-dropdown class="w-100 multiselect_custom input_ d-block" [items]="agentList"
                    [className]="'bg-white'" [showSearch]="true" [showAll]="true" [showStatus]="false"
                    (itemChange)="onAgentMultiSelectChange($event)" placeholder=" " id="agentList">
                </app-multi-dropdown>
                <label class="float-start label_ms fs-14-br-12">Agent</label>
            </div>
        </div>
        <div class="tabs_div1 tabs_div2 mt-3 mb-2">
            <div class="d-flex justify-content-between align-items-center product-items-wrapper gap-1">
                <div class="col product-items" [ngClass]="{'active1': activeTabs1 == 99}" (click)="changeTabsone(99)">
                    <span class="material-symbols-outlined text-main">grid_view </span> All
                </div>
                <div class="col product-items" [ngClass]="{'active1': activeTabs1 == 2}" (click)="changeTabsone(2)">
                    <img src="/assets/images/insurance_product/P_30X20_2.svg"> Bike
                </div>
                <div class="col product-items" [ngClass]="{'active1': activeTabs1 == 1}" (click)="changeTabsone(1)">
                    <img src="/assets/images/insurance_product/P_30X20_1.svg"> Car
                </div>
                <div class="col product-items" [ngClass]="{'active1': activeTabs1 == 3}" (click)="changeTabsone(3)">
                    <img src="/assets/images/insurance_product/P_30X20_3.svg"> Commercial
                </div>
                <div class="col product-items" [ngClass]="{'active1': activeTabs1 == 4}" (click)="changeTabsone(4)">
                    <img src="/assets/images/insurance_product/P_30X20_5.svg"> Health
                </div>
                <div class="col product-items" [ngClass]="{'active1': activeTabs1 == 6}" (click)="changeTabsone(6)">
                    <img src="/assets/images/insurance_product/P_30X20_6.svg"> Travel
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8 mt-1">
                <div class="commission_charts">
                    <div class="row mt-0 mb-3 border-bottom pb-2">
                        <div class="col-md-6 com_div1">
                            <div class="dashboard_block1 pb-2_2">
                                <ul class="d-flex justify-content-between">
                                    <li class="d-flex">
                                        <span class="material-symbols-outlined d1 success fs-34">check_circle</span>
                                        <p>Current Policy Sold <br> <span>{{policySoldCount | number}}</span></p>
                                    </li>
                                    <li>
                                        <p>Previous Policy Sold<br> <span class="text-main">{{policySoldCountPrevious | number}}</span></p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-md-6 com_div">
                            <div class="dashboard_block1 pb-2_2">
                                <ul class="d-flex justify-content-between">
                                    <li class="d-flex">
                                        <span class="material-symbols-outlined d1 success fs-34">currency_rupee_circle</span>
                                        <p>Current Sales <br> <span>{{policySoldSales | currency:'INR':'symbol':'1.0-0':'en-IN'}}</span></p>
                                    </li>
                                    <li>
                                        <p>Previous Sales <br> <span class="text-main">{{policySoldSalesPrevious | currency:'INR':'symbol':'1.0-0':'en-IN'}}</span></p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div style="width: 100%; height:300px">
                        <canvas baseChart class="chart" [data]="lineChartDataPolicySold"
                            [options]="lineChartOptionsPolicySold" [type]="lineChartType">
                        </canvas>

                    </div>
                </div>
            </div>
            <div class="col-md-4 mt-1">
                <div class="commission_charts">
                    <div class="row border-bottom my-0 pb-2">
                        <div class="col-12">Premium Company Wise</div>
                    </div>
                    <div class="row">
                        <div class="col-12 mh-343">
                            <div class="row align-items-center border-bottom my-0 justify-content-between"
                                *ngFor="let item of policySoldCompanyList">
                                <div class="col-auto">
                                    <img class="img-fluid" style="height: 50px;" title="{{item.insComStr}}"
                                        alt="{{item.insComStr}}"
                                        src="/assets/images/insurance_companies/{{item.insCom}}.png">
                                </div>
                                <div class="col-auto text-right">{{item.premium |
                                    currency:'INR':'symbol':'1.0-0':'en-IN'}}</div>
                                <div class="col-auto text-center"><span class="badge badge-info">{{item.count}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>